import * as React from 'react'
import classNames from 'classnames'

import type { Image, LinkType } from 'types'
import imgSizes from 'ui-component-library/utils/imgSizes'
import Button from 'content-components/_Primatives/Button'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Paragraph from 'content-components/_Primatives/Paragraph'
import { InlineImage } from 'content-components/_Primatives/Images'
import Link from 'content-components/_Primatives/Link'
import Ruler from '../00-Primitives/Ruler'
import rogueLogo from './images/rogue-logo.jpg'
import style from './style.scss'

type EquipmentCard = {
  headlineText: string
  image: Image
  purchaseLink: string
}

type Props = {
  className?: string
  cards: EquipmentCard[]
  equipmentPartner?: string
  headlineText: string
  link: LinkType
  paragraphText?: string
}

function EquipmentCTA({
  className,
  equipmentPartner,
  headlineText,
  paragraphText,
  cards,
  link,
}: Props) {
  return (
    <div className={classNames(style.wrapper, className)}>
      <HeadlineTwo className={style.headline}>{headlineText}</HeadlineTwo>
      <Ruler className={style.ruler} />
      <Paragraph>{paragraphText}</Paragraph>
      <div className={style.cardContainer}>
        {cards.map((card, index) => {
          const { purchaseLink, headlineText, image } = card
          return (
            <Link
              key={`${index}-${card.headlineText}`}
              className={style.card}
              url={purchaseLink}
            >
              <InlineImage
                className={style.cardPhoto}
                gradient={false}
                sizes={imgSizes(null, null, 325)}
                image={image}
              />
              <p className={style.cardText}>{headlineText}</p>
            </Link>
          )
        })}
      </div>
      <Button className={style.button} url={link.url}>
        <div className={style.buttonLogoContainer}>
          {equipmentPartner === 'rogue' && (
            <img className={style.buttonLogo} src={rogueLogo} />
          )}
        </div>
        <div className={style.buttonText}>{link.text}</div>
      </Button>
    </div>
  )
}

export default EquipmentCTA
